<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="survey-forms-table"
            :fields="fields"
            :items="customFormsIn">
            <template v-slot:cell(actions)="row">
                <div class="survey-actions">
                    <b-dropdown
                        class="ellipsis-nav survey-actions-nav"
                        no-caret
                        variant="primary"
                        right
                        toggle-class="survey-actions-context-menu">
                        <template v-slot:button-content>
                            <i class="fas fa-ellipsis-v"></i>
                        </template>

                        <b-dropdown-item
                            class="showsurvey"
                            @click.prevent.stop="showPublicUrl(row.item)">
                            <i class="icon btn-chain-link"></i> {{ $t('management.copy_form_link') }}
                        </b-dropdown-item>

                        <b-dropdown-item
                            class="showsurvey"
                            :href="routes.managementCustomFormDownload(row.item.id)">
                            <i class="icon btn-download"></i> {{ $t('management.download_form') }}
                        </b-dropdown-item>

                        <b-dropdown-item
                            class="showsurvey"
                            :href="routes.managementCustomFormDownloadPDF(row.item.id)">
                            <i class="icon btn-pdf-type"></i> {{ $t('management.download_pdf') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-custom-form-index-component',
    props: ['customFormsIn'],
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'entries_count',
                    label: this.$t('management.number_of_submitted_forms'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        showPublicUrl(customForm) {
            const url = this.routes.managementCustomFormPublicUrl(customForm.id, customForm.hash);
            this.alert.notice(this.$t('management.public_link_to_the_form'), url);
            let urlCopy = document.getElementsByClassName('swal-text')[0].innerHTML;
        },
    },
};
</script>

<style scoped lang="scss">
.survey-forms-table ::v-deep {
    .table-responsive {
        overflow: inherit;
    }
}

.survey-actions {
    display: flex;

    .btn {
        font-size: 1.125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.survey-actions-nav ::v-deep {
    .dropdown-item {
        .icon {
            color: $primary;
        }
    }
}
</style>
